import * as React from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
import { FAQ_URL, INQUIRY_FORM_URL, SiteLink } from "./links";
import SiteLinkItem from "./siteLink";

// フッターのリンクの唯一の定義
const FOOTER_LINKS: SiteLink[] = [
  { label: "首页", to: "/" },
  { label: "咨询", href: INQUIRY_FORM_URL },
  { label: "常见问题", href: FAQ_URL },
  { label: "隐私政策", to: "/privacy" },
  { label: "服务条款", to: "/terms" },
  { label: "商业信息公示", to: "/tokutei" },
];

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      © NextLab Inc. All Rights Reserved.
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: "#fcfcfc",
      }}
    >
      <Divider sx={{ mt: 4, mb: 4 }} />
      <Container maxWidth="lg">
        {/*
          折り返し可能な横並び。狭い画面では自然に複数行になるので、
          1 行 1 リンクで縦に長くなることがない。
        */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            columnGap: 3,
            rowGap: 1.5,
          }}
        >
          {FOOTER_LINKS.map((link) => (
            <SiteLinkItem key={link.label} link={link} />
          ))}
        </Box>
        <Box sx={{ mt: 4, mb: 2 }}>
          <Copyright />
        </Box>
      </Container>
    </Box>
  );
}
